import {useDataGrid} from "../../data-grid/DataGridContext";
import ApiService from "../../../Service/ApiService";
import {useEffect} from "react";
import UserDashboardData from "../../UserDashboardData";
import DataGrid from "../../data-grid/DataGrid";
import {Typography} from "antd";

export default function ({userId}) {
    const {setData, setPaginationResult, queryModel, setDataGridProps, resultModel} = useDataGrid();

    const initGridData = async () => {
        if(userId) {
            queryModel.filter = {
                userId
            }
        } else {
            queryModel.filter = {}
        }

        const response = await ApiService.AdminDashboard.GetUserDataGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel, userId])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            enableRowSelection: false,
            columns: [
                {title: 'Register Date', dataIndex: 'createdDate', key: 'createdDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`},
                {title: 'Name', dataIndex: 'name', key: 'name', sorter: false},
                {title: 'Lastname', dataIndex: 'lastname', key: 'lastname', sorter: false},
                {title: 'Email', dataIndex: 'email', key: 'email', sorter: false,},
                {title: 'Company', dataIndex: 'company', key: 'company', sorter: false,},
                {title: 'City', dataIndex: 'city', key: 'city', sorter: false,},
                {title: 'State', dataIndex: 'state', key: 'state', sorter: false,},
                {title: 'Country', dataIndex: 'country', key: 'country', sorter: false,},
                {title: 'Last IP', dataIndex: 'lastReqIp', key: 'lastReqIp', sorter: false, render: (text, record) => (<Typography.Text copyable={true}>{text}</Typography.Text>)},
                // {title: 'Last IP', dataIndex: 'lastReqIp', key: 'lastReqIp', sorter: false, render: (text, record) => (<Typography.Text copyable={true}>{text}</Typography.Text>)},
            ]
        })
    }, [])

    return (
        <>
            <DataGrid />
        </>
    )
}